<template>
  <el-dialog :title="title" :visible.sync="dialogVisible" width="1000px" @close="close">
    <div class="log-body">
      <el-form :inline="true" :model="searchForm" class="search-form">
        <template v-for="searchItem in searchList">
          <el-form-item :key="searchItem.prop">
            <component
              :is="'search-' + searchItem.type"
              :items="searchItem.items"
              v-model="searchForm[searchItem.prop]"
              @search="search"
              :attrs="searchItem.attrs"
              @change="val => searchChange(searchItem, val)"
            />
          </el-form-item>
        </template>
        <el-form-item>
          <date-picker-erp
            :is-range="true"
            v-model="searchTime"
            time-type="date"
            :default-time="['00:00:00', '23:59:59']"
            value-format="timestamp"
            :time-placeholder="['开始日期', '结束日期']"
            :max-time="maxTime"
            @change="changeDate"
          ></date-picker-erp>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">查询</el-button>
          <el-button @click="clearSearch">清空</el-button>
        </el-form-item>
      </el-form>
      <div class="content">
        <TableList ref="table" :cols="cols" :list="list" :height="400">
          <template slot="approvalStatusSlot" slot-scope="{ row }">
            <span :style="{ color: getApprovalStatusItem(row).color }">{{ getApprovalStatusItem(row).label }}</span>
          </template>
          <template slot="approvalAfterPriceSlot" slot-scope="{ row }">
            <AmountDigitText v-if="row['approvalAfterPrice']" :value="row['approvalAfterPrice'] / 100"/>
          </template>
        </TableList>
        <el-pagination
          :style="{ padding: '8px 16px', textAlign: 'right' }"
          :current-page="pageData.pageNo"
          :page-sizes="[10, 20, 50, 100, 150]"
          :page-size="pageData.pageSize"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageData.total"
        >
        </el-pagination>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import SearchSelect from '@/components/prod/center/components/SearchSelect.vue';
import SearchInput from '@/components/prod/center/components/SearchInput.vue';
import TableList from '@/components/TableList.vue';

import { approvalStatusList, searchList, colList } from './dictionary';
import { getPriceChangeApprovalRecordList } from '@servers/dangkou/index.js';
import _ from 'lodash';
import dayjs from 'dayjs';

export default {
  components: { SearchSelect, SearchInput, TableList },

  data() {
    const defaultSearchForm = {
      approvalStatusList: '',
      sourceType: 3,
      queryTimeType: 0,
      timeShortcut: 6,
    };
    const defaultTime = {
      start: dayjs().subtract(6, 'day').startOf('day').valueOf(),
      end: dayjs().endOf('day').valueOf(),
    };
    return {
      approvalStatusList,
      searchList,
      cols: colList(),
      defaultSearchForm: _.cloneDeep(defaultSearchForm),
      searchForm: _.cloneDeep(defaultSearchForm),
      searchTime: _.cloneDeep(defaultTime),
      defaultTime: _.cloneDeep(defaultTime),
      maxTime: dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
      dialogVisible: false,
      title: '',
      distributorCompanyId: '',
      row: {},
      pageData: {
        pageSize: 10,
        pageNo: 1,
        total: 0,
      },
      list: [],
    };
  },
  watch: {},
  mounted() {},
  methods: {
    openDialog(row, distributorCompanyId) {
      this.row = row;
      this.title = `【#${row.outerId || row.itemOuterId}#】改价记录`;
      this.distributorCompanyId = distributorCompanyId;
      this.dialogVisible = true;
      this.search();
    },
    close() {
      this.dialogVisible = false;
      this.clear();
      this.list = [];
    },
    async search() {
      let params = {
        distributorCompanyId: this.distributorCompanyId,
        ...this.searchForm,
        approvalStatusList: this.searchForm.approvalStatusList !== '' ? [this.searchForm.approvalStatusList] : [],
        searchStartTime: this.searchTime.start,
        searchEndTime: this.searchTime.end,
        sysItemId: this.row.sysItemId,
        sysSkuId: this.row.sysSkuId,
        pageNo: this.pageData.pageNo,
        pageSize: this.pageData.pageSize,
      };
      delete params.timeShortcut;
      const data = await getPriceChangeApprovalRecordList(params);
      const { list, total } = data;
      this.list = list || [];
      this.pageData.total = total || 0;
    },
    searchChange(item, val) {
      if (item.prop === 'timeShortcut') {
        if (val === '' || val === -1) return;
        this.searchTime = {
          start: dayjs().subtract(val, 'day').startOf('day').valueOf(),
          end: dayjs().endOf('day').valueOf(),
        };
      }
    },
    clearSearch() {
      this.clear();
      this.search();
    },
    changeDate(time, name) {
      this.searchForm.timeShortcut = -1;
    },
    clear() {
      this.pageData.pageNo = 1;
      this.searchForm = _.cloneDeep(this.defaultSearchForm);
      this.searchTime = _.cloneDeep(this.defaultTime);
    },
    pageSizeChange(size) {
      this.pageData.pageNo = 1;
      this.pageData.pageSize = size;
      this.search();
    },
    pageChange(page) {
      this.pageData.pageNo = page;
      this.search();
    },
    getApprovalStatusItem(row) {
      return this.approvalStatusList.find(v => v.value === row['approvalStatus']) || {};
    },
  },
};
</script>

<style lang="scss" scoped>
.log-body {
  .el-form-item {
    margin: 0px 4px 6px 0px;
  }
  .ml_10 {
    margin-left: 10px;
  }
  .ml_20 {
    margin-left: 20px;
  }
  .mr_10 {
    margin-right: 10px;
  }
  .fr {
    float: right;
  }
}
</style>
